import React, { useEffect, useState } from "react";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import Select from "react-select";
import { BrandsTypes } from "../../utils/constants";
import { getReportLastDay } from "./reportDateUtils";

function EcpmReport(props) {
  const { year, month, newReports } = props;
  const [ecpmData, setEcpmData] = useState([]);
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month - 1));
  const [selectedBrandType, setSelectedBrandType] = useState([2, 3, 5, 7, 9, 10,  12, 13]);
  function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  
  function getSpentForTimestamp(timestamp, type) {
    // Find the entry for the specified timestamp in the data array
    const entry = ecpmData.find((item) => item[timestamp]);

    // If the entry exists, return the spent value
    if (entry) {
      if (type === "spent")
        return parseFloat(entry[timestamp].totalSpent);
      else if (type === "clicks") return parseInt(entry[timestamp].totalClicks || 0);
      else return parseInt(entry[timestamp].totalImpressions || 0);
    }

    // If the entry doesn't exist, return null or handle accordingly based on your use case
    return 0;
  }
  const calculateEcpm = (index) => {
    let spent = getSpentForTimestamp(getTimestamp(index), "spent");
    let impressions = getSpentForTimestamp(getTimestamp(index), "impressions");
    let ecpm = (spent / impressions) * 1000;
    return !isNaN(ecpm) && ecpm !== Infinity
      ? parseFloat(ecpm).toFixed(2)
      : "-";
  };

  const calculateCTR = (index) => {
    let impressions = getSpentForTimestamp(getTimestamp(index), "impressions");
    let clicks = getSpentForTimestamp(getTimestamp(index), "clicks");
    let ctr = (clicks / impressions) * 100;
    return ctr ? ctr.toFixed(2) : "-";
  };

  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1);
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + times * 86400;
  };
  const handleCurrentDay = () => {
    setCurrentDay(getDaysInMonth(year, month - 1));
  };
  const fetchData = async () => {
    try {
      let res = await api({
        url: "/reports/ecpmreports",
        method: "POST",
        responseType: "json",
        data: {
          month,
          year,
          newReport:newReports,
          brandType: selectedBrandType
        },
      });
      if (res.code === 200) {
        setEcpmData(res.data);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {}
  };

  const getVisibleEcpmEntries = () => {
    const firstTimestamp = getTimestamp(0);
    const lastTimestamp = currentDay > 0 ? getTimestamp(currentDay - 1) : 0;

    return ecpmData?.filter((entry) => {
      const timestamp = Number(Object.keys(entry || {})[0]);
      return timestamp >= firstTimestamp && timestamp <= lastTimestamp;
    }) || [];
  };

  function getColumnTotal(type) {
    if (type === "revenue") {
      let totalRevenue = 0;
      getVisibleEcpmEntries().map((entry, index) => {
        if (entry) {
          let keys = Object.keys(entry);
          if (!keys.length) return null;
          const data = entry[keys[0]];
          if (Object.keys(data).length) {
            totalRevenue += parseFloat(data.totalSpent);
          }
        }
      })
      return parseFloat(totalRevenue).toFixed(2)
    }
    else if (type === "impressions") {
      let totalImpressions = 0;
      getVisibleEcpmEntries().map((entry, index) => {
        if (entry) {
          let keys = Object.keys(entry);
          if (!keys.length) return null;
          const data = entry[keys[0]];
          if (Object.keys(data).length) {
            totalImpressions += parseFloat(data.totalImpressions);
          }
        }
      })
      return parseInt(totalImpressions)
    }
    else if (type === "clicks") {
      let totalClicks = 0;
      getVisibleEcpmEntries().map((entry, index) => {
        if (entry) {
          let keys = Object.keys(entry);
          if (!keys.length) return null;
          const data = entry[keys[0]];
          if (Object.keys(data).length) {
            totalClicks += parseFloat(data.totalClicks);
          }
        }
      })
      return parseInt(totalClicks)
    }
  }

  const calculateAvg = (type) => {
    let ecpms = [];
    let ctrs = []
    let ecpmsSum = 0;
    let ctrsSum = 0;
    if (type === "ecpm") {
      let ecpm = 0;
      getVisibleEcpmEntries().map((entry, index) => {
        if (entry) {
          let keys = Object.keys(entry);
          if (!keys.length) return null;
          const data = entry[keys[0]];
          if (Object.keys(data).length) {
            if (data.totalClicks && data.totalImpressions) {
              ecpm = (parseFloat(data.totalSpent) / parseInt(data.totalImpressions)) * 1000
            } 
          }
          if (!isNaN(ecpm) && ecpm !== Infinity) {
            ecpms.push(ecpm);
          } 
        }
      })
      if (ecpms.length > 0) {
        ecpms.map((item) => {
        ecpmsSum += item;
      })
        return (parseFloat(ecpmsSum) / ecpms.length).toFixed(2)
      } else {
        return 0;
      }
    }
    else if (type === "ctr") {
      getVisibleEcpmEntries().map((entry, index) => {
        if (entry) {
          let keys = Object.keys(entry);
          if (!keys.length) return null;
          const data = entry[keys[0]];
          if (Object.keys(data).length) {
            let ctr;
            if (data.totalClicks && data.totalImpressions) {
              ctr = (parseInt(data.totalClicks) / parseInt(data.totalImpressions)) * 100
            }
            if (!isNaN(ctr) && ctr !== Infinity) {
              ctrs.push(ctr);
            }
          }
        }
      })
      if (ctrs.length > 0) {
        ctrs.map((item) => {
        ctrsSum += item;
      })
      return (parseFloat(ctrsSum) / ctrs.length).toFixed(2)
      }
      else {
        return 0;
      }
    }
  }

  useEffect(() => {
    fetchData();
    handleCurrentDay();
  }, [year, month, newReports, selectedBrandType]);

  return (
    <>
      <h3>eCpm Reports</h3>
      <div className="report-image">
          <Select
          isMulti
          options={BrandsTypes}
          value={BrandsTypes.filter(option => selectedBrandType.includes(option.value))}
          onChange={(selectedOptions) => setSelectedBrandType(selectedOptions.map(opt => opt.value))}
          placeholder="Select Brand Type(s)"
          className="mb-1"
          />
        <div className="overflow-x-auto">
          <table className="table table-bordered report-table" id="ecpm-report">
            <thead>
              <tr>
                <th>Date</th>
                <th>Revenue</th>
                <th>Impressions</th>
                <th>Clicks</th>
                <th>eCPM</th>
                <th>CTR</th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: currentDay }, (_, index) => (
                <tr key={index}>
                  <td>{`${index + 1}-${month}-${year}`}</td>
                  <td title={parseFloat(getSpentForTimestamp(getTimestamp(index), "spent") || 0).toFixed(2)}>{Math.round(getSpentForTimestamp(getTimestamp(index), "spent") || 0)}</td>
                  <td>
                    {getSpentForTimestamp(getTimestamp(index), "impressions")}
                  </td>
                  <td>{getSpentForTimestamp(getTimestamp(index), "clicks")}</td>
                  <td title={calculateEcpm(index)}>{calculateEcpm(index)}</td>
                  <td title={calculateCTR(index)}>{calculateCTR(index)}</td>
                </tr>
              ))}
              {ecpmData.length > 0 && <tr>
                <td>Total</td>
                <td title={getColumnTotal("revenue")}>{Math.round(parseFloat(getColumnTotal("revenue")))}</td>
                <td>{getColumnTotal("impressions")}</td>
                <td>{getColumnTotal("clicks")}</td>
                <td title={calculateAvg("ecpm")}>{calculateAvg("ecpm")}</td>
                <td title={calculateAvg("ctr")}>{calculateAvg("ctr")}</td>
              </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default EcpmReport;
